import React, { useContext, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import CopyClipboardIcon from "@material-ui/icons/FileCopyOutlined";
import { CopyToClipboard } from "react-copy-to-clipboard";
import RoomContext from "../../../context/RoomContext";
import Tooltip from "@material-ui/core/Tooltip";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      display: "flex",
      borderRadius: 24,
      border: "solid 1px #f0f3f6",
      backgroundColor: theme.palette.type === "dark" ? "#3c497d" : "#f7f8fd",
      margin: theme.spacing(0.5),
    },
    input: {
      flex: 1,
    },
    title: {
      marginLeft: 30,
      marginTop: 5,
      marginBottom: 5,
      fontWeight: 600,
    },
  })
);

const InviteBox = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { roomClient } = useContext(RoomContext);
  const [isTooltipCopied, setIsTooltipCopied] = useState(false);
  return (
    <div>
      <p className={classes.title}>
        {intl.formatMessage({
          id: "tooltip.copyInvitationLink",
          defaultMessage: "Copy invitation link",
        })}
      </p>
      <Paper className={classes.root} elevation={0}>
        <InputBase
          className={classes.input}
          style={{ color: "#3A3B3C" }}
          value={window.config.appUrl + roomClient.getRoomId()}
          disabled={true}
          autoFocus
        />
        <CopyToClipboard
          text={window.config.appUrl + roomClient.getRoomId()}
          onCopy={() => {
            setIsTooltipCopied(true);
          }}
        >
          <Tooltip
            open={isTooltipCopied}
            onClose={() => {
              setIsTooltipCopied(false);
            }}
            title={
              <h2>
                {intl.formatMessage({
                  id: "room.copiedInvitationLink",
                  defaultMessage: "Copied",
                })}
              </h2>
            }
            leaveDelay={1000}
          >
            <IconButton color="inherit" aria-label="Copy to Clipboard">
              <CopyClipboardIcon />
            </IconButton>
          </Tooltip>
        </CopyToClipboard>
      </Paper>
    </div>
  );
};

export default InviteBox;
